module.exports = __webpack_public_path__ + "img/ribbon.cd2e70a9.svg";